export default [
  {
    'text': '등록',
    'state': 'REGISTERED'
  },
  {
    'text': '처리중',
    'state': 'PROCESSING'
  },
  {
    'text': '보류',
    'state': 'SUSPENDING'
  },
  {
    'text': '처리완료',
    'state': 'DONE'
  },
];



// WEBPACK FOOTER //
// ./src/api/vocState.js